import dayjs from "dayjs";
import tz from "dayjs/plugin/timezone";

export const formatClassTime = (isoUtc: string, tz: string | null = null) => {
  const d = tz ? dayjs.utc(isoUtc).tz(tz) : dayjs(isoUtc);
  return d.format("h:mm A"); // 9:45 AM
};

export const formatGmtOffset = (isoUtc: string, tz: string | null = null) => {
  const d = tz ? dayjs.utc(isoUtc).tz(tz) : dayjs(isoUtc);
  const offsetHours = d.utcOffset() / 60;
  const sign = offsetHours >= 0 ? "+" : "";
  return `GMT${sign}${offsetHours}`;
};
